import { LightningElement, api } from "lwc";
import { assignedNodes } from "common/slot";

class pill extends LightningElement {
  @api label = "";
  @api removeButtonTitle = "Remove";
  @api variant = null;
  @api focus() {
    this.template.querySelector(".pill__remove")?.focus();
  }
  titleWithFallback = null;
  get className() {
    return ["pill", this.variant ? `pill--${this.variant}` : false]
      .filter(Boolean)
      .join(" ");
  }

  // Use slot node text as a title if the title attribute isn't provided
  setTitle() {
    const slot = this.template.querySelector("slot");
    this.titleWithFallback =
      this.title ||
      (slot
        ? assignedNodes(slot)
            .map((n) => n.textContent)
            .join("")
        : "");
    if (this.removeButtonTitle === "Remove") {
      this.removeButtonTitle = `Remove ${this.titleWithFallback}`;
    }
  }
  handleRemove(e) {
    e.stopPropagation();
    this.dispatchEvent(new CustomEvent("remove"));
  }
}

export default pill;
